module.exports = __webpack_public_path__ + "media/12.f09014c8.mp3";